import { forwardRef, MutableRefObject } from 'react';
import { FormInputProps } from '@kronoss/components/FormInput/FormInput.props';
import styles from './FormInput.module.scss';
import cn from 'classnames';

type InputRef = MutableRefObject<HTMLInputElement>;

const FormInput = forwardRef<InputRef, FormInputProps>(
  (props: FormInputProps, ref) => {
    const { label, error, inputClassName, ...rest } = props;
    return (
      <div className={cn(styles.FormInput, error && styles.Error)}>
        {label && <div className={styles.Label}>{label}</div>}
        <input
          ref={ref as any}
          {...rest}
          className={cn(styles.Input, inputClassName)}
        />
      </div>
    );
  },
);

export default FormInput;
